import React from 'react';

import CreateEvent from '../../components/events/CreateEvent';
import PageLayout from '../../components/layout/PageLayout';

const CreateEventPage = () => {
  return (
    <PageLayout>
      <CreateEvent />
    </PageLayout>
  );
};

export default CreateEventPage;
